import React, { useEffect, useState } from "react";
import _ from "lodash";
import moment from "moment";
import { INBOUND_VOLUME } from "../../../plannerConfig";
import {
  MultiWeekPlannerMainContainer,
  SplitPanelContainer,
  SplitPanel,
  YearIndicator,
  PeakInboundItem,
  PeakInboundDate,
  PeakInboundFigure,
  FigureLabel,
  FigureNumbers,
} from "./styles";
import {
  AssumptionSummaryText,
  TableSection,
  VisualisationSection,
} from "../multiWeekStyles.common";
import Visualisation from "../../Visualisations";
import LoadSpinnerOverlay from "../../LoadSpinner";
import ShiftBlock from "./shiftBlock";
import { PeakCartonCountContainer } from "../styles";
import { asFormattedValue } from "../../../helpers";

const InboundVolume = ({
  api,
  store,
  fromDate,
  toDate,
  fromDateFilter,
  toDateFilter,
  durationAggregator,
  selectedScenarios,
  scenarioStringBuilder,
  appliedFilterForDashboard,
  filterData,
  activeFrontendFilters,
}) => {
  const { data, loadingQueue } = store[INBOUND_VOLUME];
  const { CallOut, GraphA, SplitCallOut } = data;
  const [prefConfig, setPrefConfig] = useState("stackBar");

  const getPeakDayData = () => {
    const { get } = api;
    if (fromDate && toDate) {
      get([INBOUND_VOLUME], {
        routeParams: {
          fromDate,
          toDate,
          fromDateFilter,
          toDateFilter,
          durationAggregator,
          scenarios: scenarioStringBuilder(selectedScenarios),
        },
      });
    }
  };

  useEffect(() => {
    getPeakDayData();
  }, [
    fromDate,
    toDate,
    durationAggregator,
    fromDateFilter,
    toDateFilter,
    selectedScenarios,
  ]);

  if (loadingQueue.length || _.isEmpty(data)) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <LoadSpinnerOverlay text="Inbound Volume Loading..." spinning={true} />
      </div>
    );
  }
  const { title: calloutTitle, data: calloutData } = CallOut;
  const { title: splitCalloutTitle, data: splitCalloutdata } = SplitCallOut;

  const parseDate = (date) => {
    const parsedDate = moment(date, "ddd DD/MM/YYYY").format("ddd DD/MM/YY");
    return parsedDate;
  };

  const onChangePrefConfig = (value) => {
    setPrefConfig(value);
  };

  const determineApplyFilter = (data) => {
    const returnedData =
      data && data.filter && Object.keys(data.filter).length > 0
        ? appliedFilterForDashboard(
            appliedFilterForDashboard(data, activeFrontendFilters, filterData),
            [],
            data.filter
          )
        : appliedFilterForDashboard(data, activeFrontendFilters, filterData);

    return returnedData;
  };

  const filteredData = determineApplyFilter(GraphA);

  const visualisationData = {
    ...filteredData,
    data: filteredData,
    prefConfig,
    onChangePrefConfig,
  };

  const lastYearData = splitCalloutdata[0]["Last Year"];
  const thisYearsData = splitCalloutdata[1]["This Year"];

  return (
    <MultiWeekPlannerMainContainer>
      <div style={{ display: "flex", flex: 0.5 }}>
        <TableSection>
          <div style={{ flex: 0.4 }}>
            <AssumptionSummaryText>{calloutTitle}</AssumptionSummaryText>
            <div>
              {calloutData.map(({ name, date, value, units, bold }) => (
                <PeakCartonCountContainer
                  style={{ marginBottom: "1em" }}
                  bold={bold}
                  key={`${name}${value}`}
                >
                  {`${name} - ${parseDate(date)} - ${asFormattedValue(
                    value
                  )} ${units}`}
                </PeakCartonCountContainer>
              ))}
            </div>
          </div>
          <div style={{ flex: 1 }}>
            <AssumptionSummaryText>{splitCalloutTitle}</AssumptionSummaryText>
            <SplitPanelContainer style={{}}>
              <SplitPanel>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "1em",
                  }}
                >
                  <YearIndicator color="#FFB74D">Last Year</YearIndicator>
                </div>
                <div
                  style={{
                    overflow: "auto",
                    flex: 1,
                    height: "calc(100vh - 28em - 32px - 64px)",
                    maxHeight: "calc(100vh - 28em - 32px - 64px)",
                  }}
                >
                  {lastYearData.map(
                    ({ amount, capacity, date, area, shiftblocktime }) => {
                      return (
                        <PeakInboundItem>
                          <PeakInboundDate>
                            {date}
                            <ShiftBlock shiftBlock={shiftblocktime} />
                          </PeakInboundDate>
                          <PeakInboundFigure>
                            <FigureLabel>{area}</FigureLabel>
                            <FigureNumbers>{`${asFormattedValue(
                              amount
                            )} of ${asFormattedValue(
                              capacity
                            )}`}</FigureNumbers>
                          </PeakInboundFigure>
                        </PeakInboundItem>
                      );
                    }
                  )}
                </div>
              </SplitPanel>
              <SplitPanel>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "1em",
                  }}
                >
                  <YearIndicator color="#66BB6A">This Year</YearIndicator>
                </div>
                <div
                  style={{
                    overflow: "auto",
                    flex: 1,
                    height: "calc(100vh - 28em - 32px - 64px)",
                    maxHeight: "calc(100vh - 28em - 32px - 64px)",
                  }}
                >
                  {thisYearsData.map(
                    ({ amount, capacity, date, area, shiftblocktime }) => {
                      return (
                        <PeakInboundItem>
                          <PeakInboundDate>
                            {date}
                            <ShiftBlock shiftBlock={shiftblocktime} />
                          </PeakInboundDate>
                          <PeakInboundFigure>
                            <FigureLabel>{area}</FigureLabel>
                            <FigureNumbers>{`${asFormattedValue(
                              amount
                            )} of ${asFormattedValue(
                              capacity
                            )}`}</FigureNumbers>
                          </PeakInboundFigure>
                        </PeakInboundItem>
                      );
                    }
                  )}
                </div>
              </SplitPanel>
            </SplitPanelContainer>
          </div>
        </TableSection>
      </div>
      <div style={{ display: "flex", flex: "1" }}>
        <VisualisationSection>
          <Visualisation {...visualisationData} />
        </VisualisationSection>
      </div>
    </MultiWeekPlannerMainContainer>
  );
};

export default InboundVolume;
